import {
  as400ItemNumberFormatProblem,
  suggestCollisionAdjustment,
} from '@erp/rpc';
import type { CellRule } from '../as400CellRuleKinds';

const ITEMNO = 'ITEMNO';

export function itemNumberFormatRule(field = ITEMNO): CellRule {
  return {
    field,
    check(value) {
      if (value === null || value === '') return null;
      const problem = as400ItemNumberFormatProblem(value);
      return problem === null ? null : { rule: 'item-number-format', problem };
    },
  };
}

export function itemNumberCollisionRule(
  taken: ReadonlySet<string>,
  field = ITEMNO,
): CellRule {
  return {
    field,
    check(value) {
      if (value === null || value === '') return null;
      const folded = value.trim().toUpperCase();
      if (!taken.has(folded)) return null;
      return {
        rule: 'item-number-collision',
        suggestion: suggestCollisionAdjustment(folded),
      };
    },
  };
}
